import { ReactNode, useState } from 'react';
import { EMPTY_FLOORPLAN, Floorplan } from '@domain/floorplan';

import { FloorplanContext } from './floorplan-context';

export const FloorplanProvider = ({ children }: { children: ReactNode }) => {
  const [floorplanState, setFloorplanState] = useState<Floorplan>(EMPTY_FLOORPLAN);

  const updateFloorPlanState = (props: Partial<Floorplan>) => {
    setFloorplanState({ ...floorplanState, ...props });
  };
  const resetFloorplanState = () => {
    setFloorplanState(EMPTY_FLOORPLAN);
  };

  return (
    <FloorplanContext.Provider
      value={{
        floorplanState,
        setFloorplanState,
        resetFloorplanState,
        updateFloorPlanState,
      }}>
      {children}
    </FloorplanContext.Provider>
  );
};
